module.exports = __webpack_public_path__ + "img/h_product_1.6708635.jpg";